/** Dev aid: write the exact internal frame to docs/lookdev/<name>.png through the dev server (05 §12). */

import type { Scene } from 'three';
import type { PixelCamera } from '../render/camera/PixelCamera';
import type { RenderPipeline } from '../render/pipeline/RenderPipeline';

const W = 640;
const H = 360;
const TARGET_W = 642;

export async function saveFrame(pipeline: RenderPipeline, scene: Scene, camera: PixelCamera, name: string, scale = 2): Promise<string> {
  pipeline.render(scene, camera);
  const src = pipeline.readPixels();
  const small = document.createElement('canvas');
  small.width = W;
  small.height = H;
  const big = document.createElement('canvas');
  big.width = W * scale;
  big.height = H * scale;
  const ctx = small.getContext('2d');
  const out = big.getContext('2d');
  if (!ctx || !out) throw new Error('no 2d context');
  const image = ctx.createImageData(W, H);
  for (let y = 0; y < H; y++) {
    // readPixels is bottom-up; skip the 1-texel border.
    const row = (H - y) * TARGET_W + 1;
    for (let x = 0; x < W; x++) {
      const i = (row + x) * 4;
      const o = (y * W + x) * 4;
      image.data[o] = src[i] ?? 0;
      image.data[o + 1] = src[i + 1] ?? 0;
      image.data[o + 2] = src[i + 2] ?? 0;
      image.data[o + 3] = 255;
    }
  }
  ctx.putImageData(image, 0, 0);
  out.imageSmoothingEnabled = false;
  out.drawImage(small, 0, 0, big.width, big.height);
  const res = await fetch(`/__lookdev/save?name=${encodeURIComponent(name)}`, { method: 'POST', body: big.toDataURL('image/png') });
  return res.text();
}
